import { stat } from "fs-extra";
import { OnAnimationFrame } from "../../../library-js/animation/OnAnimationFrame";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { EventSlot } from "../../../library-js/events/EventSlot";
import { LanguageCode, LanguageCodes } from "../../../library-js/i18n/LanguageCode";
import { PHPUser } from "../../../library-js/php/user/PHPUser";
import { Rokojori } from "../Rokojori";

export class UserData
{
  hasUser:boolean = false;
  userName:string = null;

  equals( other:UserData )
  {
    return this.hasUser === other.hasUser && this.userName === other.userName;
  }
}

export class RokojoriUser extends PHPUser
{
  readonly onUserChange = new EventSlot<UserData>(); 
  private _checkingStatus = false;
  private _lastCheck = 0;
  private _checkDuration = 5;
  private _isFirstCheck = true;
  private _naviHeader = new ElementType<HTMLElement>( "navi-header" );
  private _currentUserData:UserData = new UserData();
  get currentUserData()
  {
    return this._currentUserData;
  }

  initialize( onAnimationFrame:OnAnimationFrame )
  {
    if ( ClassFlag.debugging.in( document.body ) )
    {
      return;
    }
    
    onAnimationFrame.addListener(
      ()=>
      {
        
        this._update();
      }
    )
  }

  private _update()
  {
    if ( this._checkingStatus )
    {
      return;
    }

    if ( ! Rokojori.$.activityAnalyser.active )
    {
      return;
    }

    let timeElapsedMS = new Date().getTime() - this._lastCheck;
    let checkDurationInMS = this._checkDuration * 1000;

    if ( timeElapsedMS > checkDurationInMS )
    {
      this._checkStatus();
    }
  }

  

  private async _checkStatus( forceUpdate:boolean = false)
  {
    this._checkingStatus = true;
    this._lastCheck = new Date().getTime();
    
    let status = await this.loginStatus();

    let newUserData = new UserData();

    newUserData.hasUser = ! status.error;
    newUserData.userName = null;

    if ( newUserData.hasUser )
    {
      newUserData.userName = status.userName;
    }

    this._checkingStatus = false;

    let needsUpdate = forceUpdate || this._isFirstCheck || ! newUserData.equals( this._currentUserData );

    if ( ! needsUpdate )
    {
      return;
    }

    this._isFirstCheck = false;
    this._currentUserData = newUserData;
   

    this.onUserChange.dispatch( this._currentUserData );

  }

  updateUserStatus()
  {
    this._checkStatus();
  }

  get language()
  {
    return ( Rokojori.$.pageHandler.currentLanguage as LanguageCode ) || LanguageCodes.en;
  }

  get phpContext()
  {
    return Rokojori.phpContext;
  }
}